import React from 'react';
import { Avatar, Box, Card, Typography } from '@mui/material';
import { Facebook as FacebookIcon, Instagram as InstagramIcon } from '@mui/icons-material';
import { FACEBOOK_TYPE, INSTAGRAM_TYPE } from '../../../../actions/marketingHub';

const ProfileCard = ({ type = '', name = '', picture = '' }) => (
  <Box width={150} minHeight={162} height="100%" boxShadow={25}>
    <Card variant="outlined" style={{ height: '100%' }}>
      <Box display="flex" flexDirection="column" justifyContent="space-evenly" alignItems="center" height="100%">
        <Box display="flex" justifyContent="center">
          {type === FACEBOOK_TYPE && <FacebookIcon />}
          {type === INSTAGRAM_TYPE && <InstagramIcon />}
          <Typography>{type}</Typography>
        </Box>
        <Box mt={1}>
          <Avatar src={picture} sx={{ width: '56px', height: '56px' }} />
        </Box>
        <Typography sx={{ textAlign: 'center' }}>{name}</Typography>
      </Box>
    </Card>
  </Box>
);

export default ProfileCard;
